import * as React from "react";
import { HttpRequest } from '../../util/http';
import { CheckBox } from "../../components/ui/CheckBox";
import { RadioGroup } from "../../components/ui/RadioGroup";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { FontAwesomeIcon } from '../../components/ui/FontAwesomeIcon';
import DatePicker from "react-datepicker";
import {format} from "date-fns";
import { HierarchyDataSource } from '../../components/ui/FiltersBar/DataSources';
import { userData } from "util/userData";
import {IActiveFiltersSet, IAvidCheckBox, IAvidCheckTracker} from './interfaces';
import TeamSelector from "./lib/teamSelector";
import * as _ from "lodash";

interface checkBox {
  isEnabled: boolean
  isChecked: boolean
  label: string
}

interface checkBoxGroup {
  title: string
  isCollapsed: boolean
  checkBoxes: checkBox[]
}

interface containerProps {
  title: string
  handler: (filters: any) => void
  reasonFilters: string[]
  statusFilters: string[]
  rootCauseFilters: string[]
  sourceFilters: string[]
  severityFilters: string[]
  teamFilters: string[]
}

interface hierarchyFilter {
  trail: Avid[]
  current: Avid
  children: Avid[]
}

interface Avid {
  id: number
  label: string
  prevLink: string
  nextLink: string
  hierarchyLevel: string
  defaultUser: number
  customer: string
  childCount: number
  childAvids?: Avid[]
  defaultAssignee: number
  defaultAssigneeRecordID?: number
}

interface containerState {
  title: string
  collapsed: boolean
  periodFilter?: DateRange
  isPeriodFilterCollapsed: boolean
  isHierarchyFilterCollapsed: boolean
  isHierarchyDropdownOpen: boolean
  reasonFilters: filterListCheckBox
  statusFilters: filterListCheckBox
  rootCauseFilters: filterListCheckBox
  severityFilters: filterListCheckBox
  sourceFilters: filterListCheckBox
  trendInputs: checkBoxGroup
  trendActiveFilter: string
  filtersLoadedCount: number
  defaultHeriarchyValue?: string
  heirarchyValues: string[]
  hierarchyFilter: hierarchyFilter
  isTeamFilterCollapsed: boolean
  avidCheckboxes: IAvidCheckBox[]
  AvidsList: IAvidCheckTracker[]
  avidsGroupedByParent: any
  defaultCheckbox: string
  highestAvid?: string
}

class filterListCheckBox {
  title: string;
  path: string
  type: string
  types: string
  isCollapsed: boolean;
  checkBoxes: checkBox[];
  activeFilters: string[];
  filters: string[];
  hasFilters: boolean
  constructor(title: string, path: string, types: string, type: string) {
    this.title = title;
    this.path = path;
    this.types = types;
    this.type = type;
    this.isCollapsed = true;
    this.checkBoxes = [];
    this.activeFilters = [];
    this.filters = [];
    this.hasFilters = false;
  }

  getOptions() {
    const method = 'POST';
    return HttpRequest.fetch(this.path, { method })
      .then((res: any) => {
        let filteredItems  = res
        if (this.type === 'status')
          filteredItems.statusTypes = filteredItems.statusTypes.filter((i) => {
            return i.status !== 'New' && i.status !== 'Pending'
          })

        this.checkBoxes = [];
        this.activeFilters = [];
        if (this.types.length > 0 && filteredItems[this.types] !== undefined) {
          filteredItems[this.types].forEach((item) => {
            this.checkBoxes.push({
              label: (item[this.type] == 'Coaching Form' ? 'Survey' : item[this.type]),
              isChecked: false,
              isEnabled: true
            });
            this.activeFilters.push((item[this.type] == 'Coaching Form' ? 'Survey' : item[this.type]));
            this.filters.push((item[this.type] == 'Coaching Form' ? 'Survey' : item[this.type]));
          });
          if (this.type !== 'status' && this.type !== 'name') { // There should not be Not Assigned Status option
            this.checkBoxes.push({label: 'No ' + [this.title] + ' Assigned', isChecked: false, isEnabled: true});
            this.activeFilters.push('No ' + [this.title] + ' Assigned');
            this.filters.push('No ' + [this.title] + ' Assigned');
          }
        } else {
          filteredItems.forEach((item) => {
            this.checkBoxes.push({ label: (item[this.type] == 'Coaching Form' ? 'Survey' : item[this.type]), isChecked: false, isEnabled: true });
            this.activeFilters.push((item[this.type] == 'Coaching Form' ? 'Survey' : item[this.type]));
            this.filters.push((item[this.type] == 'Coaching Form' ? 'Survey' : item[this.type]));
          });
          if (this.type !== 'status' && this.type !== 'name') { // There should not be Not Assigned Status option
            this.checkBoxes.push({label: 'No ' + [this.title] + ' Assigned', isChecked: false, isEnabled: true});
            this.activeFilters.push('No ' + [this.title] + ' Assigned');
            this.filters.push('No ' + [this.title] + ' Assigned');
          }
        }
      })
  }

  getPastMonths() {

  }

  updateActiveFilters(parent?: any) {
    let activeFilters = []
    this.checkBoxes.forEach((option) => {
      if (option.isChecked) {
        activeFilters.push(option.label);
        this.hasFilters = true;
      }
    });
    if (activeFilters.length == 0 || activeFilters.length == this.filters.length) {
      activeFilters = this.filters;
      this.hasFilters = false;
    }
    this.activeFilters = activeFilters;
    return activeFilters;
  }
}

interface DateRange {
  startOfdateRange: Date
  endOfdateRange: Date
  period: string
}

export class ReportsFilersBar extends React.Component<containerProps, containerState> {
  state: containerState = {
    title: '',
    collapsed: false,
    isPeriodFilterCollapsed: false,
    isHierarchyFilterCollapsed: false,
    isHierarchyDropdownOpen: false,
    reasonFilters: new filterListCheckBox('Reason for Alert', 'scripts/my_alerts/get_reason_list', 'reasons', 'reason'),
    statusFilters: new filterListCheckBox('Status', 'scripts/alert_form/get_status_types', 'statusTypes', 'status'),
    sourceFilters: new filterListCheckBox('Source', 'scripts/action_alerts_reports/actionalerttype/get', '', 'name'),
    rootCauseFilters: new filterListCheckBox('Root Cause', 'scripts/admin_action_alerts/rootcause/get_checkboxes', 'rootCauses', 'rootCause'),
    severityFilters: new filterListCheckBox('Severity', 'scripts/alert_form/get_severity_list', 'severityList', 'severity'),
    trendInputs: {
      title: 'Trend By',
      isCollapsed: true,
      checkBoxes: [
        { label: 'Month', isEnabled: true, isChecked: true },
        { label: 'Quarter', isEnabled: true, isChecked: false },
        { label: 'Year', isEnabled: true, isChecked: false }
      ]
    },
    trendActiveFilter: 'Month',
    filtersLoadedCount: 0,
    heirarchyValues: [],
    hierarchyFilter: {
      trail: [],
      current: undefined,
      children: []
    },
    isTeamFilterCollapsed: false,
    avidCheckboxes: [],
    AvidsList: [],
    avidsGroupedByParent: [],
    defaultCheckbox: 'myAlerts'
  }

  constructor(props) {
    super(props);
    this.state.title = this.props.title;

  }
  componentWillMount() {
    HierarchyDataSource.setShowAllCoachingFormOption(true);
    userData.filtersListen((filters) => {
      const defaultHeriarchyValue = filters.hier
      this.setState({ defaultHeriarchyValue });
    });
  }

  componentDidMount() {
    this.setInitialDateRangeState();
    this.state.reasonFilters.getOptions().then(() => {
      let { filtersLoadedCount } = this.state;
      this.setState({ filtersLoadedCount: filtersLoadedCount + 1 });
      this.filtersHandler();
    });
    this.state.statusFilters.getOptions().then(() => {
      let { filtersLoadedCount } = this.state;
      this.setState({ filtersLoadedCount: filtersLoadedCount + 1 });
      this.filtersHandler();
    });
    this.state.rootCauseFilters.getOptions().then(() => {
      let { filtersLoadedCount } = this.state;
      this.setState({ filtersLoadedCount: filtersLoadedCount + 1 });
      this.filtersHandler();
    });
    this.state.severityFilters.getOptions().then(() => {
      let { filtersLoadedCount } = this.state;
      this.setState({ filtersLoadedCount: filtersLoadedCount + 1 });
      this.filtersHandler();
    });
    this.state.sourceFilters.getOptions().then(() => {
      let { filtersLoadedCount } = this.state;
      this.setState({ filtersLoadedCount: filtersLoadedCount + 1 });
      this.filtersHandler();
    });
    const filters = userData.getFilters();
    // let { hierarchyFilter } = this.state;
    // hierarchyFilter.current = (filters.hier ? filters.hier : '');
    this.setState({
      heirarchyValues: (filters.hier ? [filters.hier] : []),
      // hierarchyFilter: hierarchyFilter
    }, () => {
    });
    this.getHierarchy((filters.hier ? filters.hier : 'Bankwide_0'));
    HierarchyDataSource.sync(true);
    this.getAvidsLegacy();
  }

  componentDidUpdate(prevProps: Readonly<containerProps>, prevState: Readonly<containerState>, snapshot?: any) {
    if (this.props.reasonFilters != prevProps.reasonFilters) {
      let {reasonFilters} = this.state;
      reasonFilters.checkBoxes.forEach((option) => {
        if (this.props.reasonFilters.includes(option.label) && this.props.reasonFilters.length > 0 && this.props.reasonFilters.length < reasonFilters.filters.length) {
          option.isChecked = true;
        } else option.isChecked = false;
      });
      const reasonActiveFilters = reasonFilters.updateActiveFilters();
      this.setState({reasonFilters: reasonFilters});

    }
    if (prevState.reasonFilters != this.state.reasonFilters)
      this.filtersHandler();
    if (this.props.statusFilters != prevProps.statusFilters) {
      let {statusFilters} = this.state;
      statusFilters.checkBoxes.forEach((option) => {
        if (this.props.statusFilters.includes(option.label) && this.props.statusFilters.length > 0 && this.props.statusFilters.length < statusFilters.filters.length) {
          option.isChecked = true;
        } else option.isChecked = false;
      });
      const reasonActiveFilters = statusFilters.updateActiveFilters();
      this.setState({statusFilters: statusFilters});

    }
    if (this.props.rootCauseFilters != prevProps.rootCauseFilters) {
      let {rootCauseFilters} = this.state;
      rootCauseFilters.checkBoxes.forEach((option) => {
        if (this.props.rootCauseFilters.includes(option.label) && this.props.rootCauseFilters.length > 0 && this.props.rootCauseFilters.length < rootCauseFilters.filters.length) {
          option.isChecked = true;
        } else option.isChecked = false;
      });
      const reasonActiveFilters = rootCauseFilters.updateActiveFilters();
      this.setState({rootCauseFilters: rootCauseFilters});

    }

    if (this.props.sourceFilters != prevProps.sourceFilters) {
      let {sourceFilters} = this.state;
      sourceFilters.checkBoxes.forEach((option) => {
        if (this.props.sourceFilters.includes(option.label) && this.props.sourceFilters.length > 0 && this.props.sourceFilters.length < sourceFilters.filters.length) {
          option.isChecked = true;
        } else option.isChecked = false;
      });
      const reasonActiveFilters = sourceFilters.updateActiveFilters();
      this.setState({sourceFilters: sourceFilters});

    }

    if (this.props.severityFilters != prevProps.severityFilters) {
      let {severityFilters} = this.state;
      severityFilters.checkBoxes.forEach((option) => {
        if (this.props.severityFilters.includes(option.label) && this.props.severityFilters.length > 0 && this.props.severityFilters.length < severityFilters.filters.length) {
          option.isChecked = true;
        } else option.isChecked = false;
      });
      const reasonActiveFilters = severityFilters.updateActiveFilters();
      this.setState({severityFilters: severityFilters});

    }

    // if (prevState.AvidsList != this.state.AvidsList) this.filtersHandler();

    if (this.props.teamFilters != prevProps.teamFilters) {
      let updatedAvidsList = Object.assign(this.state.AvidsList);
      let checkedAvids = [];
      updatedAvidsList.forEach((avid) => {
        if (avid.isChecked) checkedAvids.push(avid.text)
      });
      let diff = '';
      checkedAvids.forEach((tag) => {
        if (!this.props.teamFilters.includes(tag)) diff = tag;
      });
      if (diff.length > 0) {
        const diffAvidId = updatedAvidsList.find((item) => item.text == diff).id
        this.toggleTeamCheckbox(diffAvidId, diffAvidId);
      } else if (this.props.teamFilters.length == 0) {
        if (this.state.defaultCheckbox === 'myAlerts') {
          this.toggleTeamCheckbox('myAlerts', 'myAlerts');
          this.setState({defaultCheckbox: this.state.highestAvid})
        }
        else {
          this.toggleTeamCheckbox(this.state.highestAvid, this.state.highestAvid);
          this.setState({defaultCheckbox: 'myAlerts'})
        }
      }
    }
  }

  getHierarchy(current: string) {
    const project = userData.getCurrentProject();
    const data = { currentHierarchy: current, current_project: project };
    const method = 'POST';
    HttpRequest.fetch('scripts/admin_action_alerts/get_avid', { data, method })
      .then((res: Avid) => {
        let { hierarchyFilter } = this.state;
        hierarchyFilter.current = res;
        this.setState({ hierarchyFilter: hierarchyFilter }, () => this.getHierarchyChildren(current));
      });
  }

  /**
   * Checks whether curren hierarchy has a parent trail and returns it if it does
   * @param currentHier Starting point for searching parents
   */
  getHierarchyTrail(currentHier: string) {
    return []
  }

  /**
   * Checks whether curren hierarchy has a children and returns them if it does
   * @param currentHier Starting point for searching children
   */
  getHierarchyChildren(currentHier: string) {
    const project = userData.getCurrentProject();
    let data = { current_project: project, parentId: currentHier };
    const method = 'POST';
    HttpRequest.fetch('scripts/admin_action_alerts/get_avids', { data, method })
      .then((res: Avid[]) => {
        let { hierarchyFilter } = this.state;
        let avids = [];
        res.forEach((avid) => {
          avids.push(avid);
        });
        hierarchyFilter.children = avids;
        this.setState({ hierarchyFilter: hierarchyFilter });
      });
  }

  /**
   * Get avid (Team) options
   */
  getAvidsLegacy() {
    userData.getUserId().then((userId) => {
      HttpRequest.fetch(`scripts/avids/avids_get_nested_based_on_user?user_id=${userId}&type=COACHINGFORM&project=${userData.getCurrentProject()}`)
        .then((res: INestedAvid) => {
          let avids = [];
          avids.push(res);
          avids.push({ isChecked: true, text: 'My Alerts', id: 'myAlerts', children: []})
          let AvidList = this.flatten(res.children, x => x.children);
          AvidList.push(res);
          this.setState({avidCheckboxes: avids, AvidsList: AvidList, highestAvid: res.id}, () => {
            let newAvidsList = Object.assign(this.state.AvidsList);
            newAvidsList.push(
              { isChecked: true, text: 'My Alerts', id: 'myAlerts', children: [], state: {selected: true}}
            )
            newAvidsList.forEach((avid) => {
              avid.isChecked = avid.id == 'myAlerts';
              avid.childrenCollapsed = !(avid.id == 'myAlerts' || avid.id == 'Bankwide_0');
            });

            let groupedByParent = _.groupBy(AvidList, 'prevLink');
            this.setState({AvidsList: newAvidsList, avidsGroupedByParent: groupedByParent}, this.filtersHandler);
          });
        })
    })
  }

  /**
   * Get a flatten list of Avids
   */
  flatten(xs, childSelector) {
    return xs.reduce((acc, x) => {
      acc = acc.concat(x);
      let children = childSelector(x);
      if (children) {
        acc = acc.concat(this.flatten(children, childSelector));
      }
      return acc;
    }, []);
  }


  /**
   * Updates hierarchy filter
   * @param hierarchy Soon to be next Hierarchy
   */
  updateHierarchyFilter(hierarchy: Avid) {
    let { hierarchyFilter } = this.state;
    const currenHier = hierarchyFilter.current;
    const trail = hierarchyFilter.trail;
    hierarchyFilter.current = hierarchy;
    this.setState({ hierarchyFilter: hierarchyFilter }, () => {
      this.getHierarchyChildren(hierarchy.nextLink);
      this.updateHierTrail(currenHier, trail.indexOf(hierarchy), trail);
      this.filtersHandler();
    });
  }

  /**
   * Adss/Deletes Element from the trail
   * @param avid Node to be pushed/deleted
   * @param pos Position in array, -1 if it's not in
   */
  updateHierTrail(avid: Avid, pos: number, trail: Avid[]) {
    let { hierarchyFilter } = this.state;
    // let trail = hierarchyFilter.trail;
    let updtatedTrail = [];
    if (pos == -1) {
      trail.push(avid);
    }
    if (pos >= 0) {
      updtatedTrail = trail.slice(0, pos);
      trail = updtatedTrail;
    }
    hierarchyFilter.trail = trail;
    this.setState({ hierarchyFilter: hierarchyFilter });
  }

  filtersHandler() {
    let { periodFilter, reasonFilters, rootCauseFilters, severityFilters, sourceFilters, statusFilters, trendActiveFilter, hierarchyFilter, AvidsList } = this.state;

    let defaultTeams = [];
    let checkedTeams = [];

    AvidsList.forEach((i) => {
      defaultTeams.push(i.text);
      if (i.isChecked) checkedTeams.push(i.text);
    });

    const teamHasBeenFiltered = defaultTeams.length !== checkedTeams.length;

    const activeFiltersSet: IActiveFiltersSet = {
      AvidsList: ((AvidsList && AvidsList.length > 0) ? AvidsList : []),
      periodFilter: periodFilter ? periodFilter.period : '',
      reasonFilters: {isFiltered: reasonFilters.hasFilters, filteredList: reasonFilters.activeFilters, defaultList: reasonFilters.filters},
      rootCauseFilters: {isFiltered: rootCauseFilters.hasFilters, filteredList: rootCauseFilters.activeFilters, defaultList: rootCauseFilters.filters},
      severityFilters: {isFiltered: severityFilters.hasFilters, filteredList: severityFilters.activeFilters, defaultList: severityFilters.filters},
      sourceFilters: {isFiltered: sourceFilters.hasFilters, filteredList: sourceFilters.activeFilters, defaultList: sourceFilters.filters},
      statusFilters: {isFiltered: statusFilters.hasFilters, filteredList: statusFilters.activeFilters, defaultList: statusFilters.filters},
      trendActiveFilter: trendActiveFilter,
      hierFilter: (hierarchyFilter ? hierarchyFilter : undefined),
      teamFilters: {isFiltered: teamHasBeenFiltered, filteredList: checkedTeams, defaultList: defaultTeams}
    }
    this.props.handler(activeFiltersSet);
  }

  setInitialDateRangeState() {
    // NOTE: If first time loading Date Picker, date range should be default to current month
    // as in firstDayOfMonth - lastDayOfMonth
    const method = 'POST';
    HttpRequest.fetch('/scripts/action_alerts_reports/getInitialDateRange', { method }).then((res: any) => {

      const currentDate = new Date();
      const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

      this.updateDateRange(firstDayOfMonth, currentDate);
    })
  }

  updateDateRange(startDate: Date, endDate: Date) {
    let periodFilter: DateRange = { startOfdateRange: startDate, endOfdateRange: endDate, period: '' }
    periodFilter.startOfdateRange = startDate;
    periodFilter.endOfdateRange = endDate;
    const fromDate = format(new Date(startDate), 'yyyy/MM/dd');
    const toDate = format(new Date(endDate), 'yyyy/MM/dd');
    let dateRange = fromDate + '-' + toDate;
    periodFilter.period = dateRange;
    this.setState({ periodFilter: periodFilter }, () => this.filtersHandler());
  }

  toggleTeamCheckbox(selectedAvid: string, originAvid: string): void {
    let newAvidsList: IAvidCheckTracker[] = Object.assign(this.state.AvidsList);
    if (selectedAvid != 'myAlerts' && newAvidsList.length > 0) {
      const avidsGroupedByParent: IAvidCheckTracker[] = Object.assign(this.state.avidsGroupedByParent);
      const clickedAvid = newAvidsList.find((avidObj) => avidObj.id == selectedAvid);
      const isSelected = clickedAvid.isChecked;
      let activeChildren = 0;
      const listOfChildren = this.flatten(clickedAvid.children, x => x.children);
      const listOfChildrenIds = listOfChildren.map((avid) => {
        if (avid.isChecked) activeChildren += 1;
        return avid.id
      });

        let selectParent = activeChildren == listOfChildren.length;

    let updatedChildAvids = newAvidsList.map((avid) => {
      // toggle value only when it is first method call
      if (originAvid === selectedAvid) {
        if (avid.id == selectedAvid || listOfChildrenIds.includes(avid.id)) {
          avid.isChecked = !isSelected;
        }
      } else {
      //  this means we are looking to update the parent
        if (avidsGroupedByParent.hasOwnProperty(selectedAvid) && avid.id == selectedAvid) {
          avid.isChecked = selectParent;
        } else this.filtersHandler();
      }
      if (avid.id == 'myAlerts') avid.isChecked = false;
      return avid;
    });

      this.setState({AvidsList: updatedChildAvids}, () => {
        this.filtersHandler();
        if (clickedAvid.distance > 0) {
          this.toggleTeamCheckbox(clickedAvid.prevLink, selectedAvid)
        }
      });
    } else {
      const myAlertsCheckBox = newAvidsList.find(cb => cb.id == 'myAlerts');
      let activeCheckboxes = 0;
      newAvidsList.forEach((item) => {
        if (item.id == 'myAlerts') item.isChecked = !myAlertsCheckBox.isChecked
        else item.isChecked = myAlertsCheckBox.isChecked
        if (item.isChecked) activeCheckboxes += 1;
      });

      if (activeCheckboxes > 0) {
        this.setState({AvidsList: newAvidsList}, () => {
          this.filtersHandler()
        });
      }
    }
  }

  renderCheckBoxFilterList(list: filterListCheckBox, name: string) {
    let partialState = {};
    return (
      <>
        <h5 className='d-flex justify-content-between'>{list.title} <i className={(list.isCollapsed ? "fas fas fa-angle-right" : "fas fa-angle-down")} onClick={() => {
          list.isCollapsed = !list.isCollapsed;
          partialState[name] = list;
          this.setState(partialState);
        }}/></h5>
        <div className={(list.isCollapsed ? "collapse" : "collapse show")}>
          {list.checkBoxes.map((input, idx) => {
            return (
              <CheckBox
                isChecked={input.isChecked}
                isEnabled={input.isEnabled}
                label={input.label}
                key={idx}
                onChange={(isChecked) => {
                  list.checkBoxes.forEach((option) => {
                    if (option.label == input.label)
                      option.isChecked = isChecked;
                  });
                  list.updateActiveFilters();
                  partialState[name] = list;
                  this.setState(partialState, () => this.filtersHandler());
                }}
              />
            );
          }
          )}
        </div>
      </>
    );
  }

  renderRadioGroup(list: checkBoxGroup, name: string) {
    return (
      <>
        <h5 className='d-flex justify-content-between'>{list.title} <i className={(list.isCollapsed ? "fas fas fa-angle-right" : "fas fa-angle-down")} onClick={() => {
          list.isCollapsed = !list.isCollapsed;
          let partialState = {};
          partialState[name] = list;
          this.setState(partialState);
        }}></i></h5>
        <div className={(list.isCollapsed ? "collapse" : "collapse show")}>
          <RadioGroup
            options={this.state.trendInputs.checkBoxes}
            onChange={(filter) => {
              let {trendInputs} = this.state;
              let updatedOptions = []
              trendInputs.checkBoxes.forEach((item) => {
                updatedOptions.push({ label: item.label, isChecked: (filter == item.label), isEnabled: true });
              });
              trendInputs.checkBoxes = updatedOptions;
              this.setState({trendActiveFilter: filter, trendInputs: trendInputs}, () => this.filtersHandler())
            }}
          />
        </div>
      </>
    );
  }

  renderDatePicker() {
    let { periodFilter, isPeriodFilterCollapsed } = this.state;
    if (periodFilter) {
      return (
        <>
          <h5 className='d-flex justify-content-between' style={{border: 'none', paddingBottom: 0}}>
            Period <i className={(isPeriodFilterCollapsed ? "fas fas fa-angle-right" : "fas fa-angle-down")} onClick={() => {
            this.setState({ isPeriodFilterCollapsed: !isPeriodFilterCollapsed });
          }}></i></h5>
          <span style={{borderBottom: '1px solid rgba(0, 0, 0, 0.1)', marginBottom: '1.25rem', display: 'block'}}>Based on Creation Date</span>
          {!isPeriodFilterCollapsed &&
            <div className='filters-bar-container'>
              <div className="datepicker-container" style={{ display: 'flex' }}>
                <DatePicker
                  selected={periodFilter.startOfdateRange}
                  onChange={date => { this.updateDateRange(date, periodFilter.endOfdateRange) }}
                  selectsStart
                  startDate={periodFilter.startOfdateRange}
                  endDate={periodFilter.endOfdateRange}
                />
                <DatePicker
                  selected={periodFilter.endOfdateRange}
                  onChange={date => { this.updateDateRange(periodFilter.startOfdateRange, date) }}
                  selectsEnd
                  startDate={periodFilter.startOfdateRange}
                  endDate={periodFilter.endOfdateRange}
                  minDate={periodFilter.startOfdateRange}
                />
              </div>
            </div>
          }
        </>
      );
    }
  }

  toggleHier() {
    const { isHierarchyDropdownOpen } = this.state;
    this.setState({ isHierarchyDropdownOpen: !isHierarchyDropdownOpen });
  }
  getHierarchyFilter() {
    const { isHierarchyFilterCollapsed, hierarchyFilter } = this.state;
    const { trail } = hierarchyFilter;
    const { current } = hierarchyFilter;
    const { children } = hierarchyFilter;
    const isOpen = this.state.isHierarchyDropdownOpen;
    if (current) {
      return (
        <>
          <h5 className='d-flex justify-content-between'>Hierarchy <i className={(isHierarchyFilterCollapsed ? "fas fas fa-angle-right" : "fas fa-angle-down")} onClick={() => {
            this.setState({ isHierarchyFilterCollapsed: !isHierarchyFilterCollapsed });
          }}></i></h5>
          <Dropdown isOpen={isOpen} toggle={() => this.toggleHier()}>
            <DropdownToggle caret outline color='dark' className='user-select-dropdown'>
              <p className='d-flex justify-content-between'>
                Hierarchy: {current.label}
                <span><FontAwesomeIcon icon="caret-down" fixedWidth /></span>
              </p>
            </DropdownToggle>
            <DropdownMenu className='user-select-dropdown-menu'>
              {trail.map((avid, idx) => {
                return (
                  <DropdownItem key={'trail-avids-dropdown-' + idx} onClick={() => this.updateHierarchyFilter(avid)}>
                    {avid.label}
                  </DropdownItem>
                );
              })}
              {trail.length > 0 &&
                <DropdownItem divider />
              }
              <DropdownItem header>{current.label}</DropdownItem>
              {children.length > 0 &&
                <DropdownItem divider />
              }
              {children.map((avid, idx) => {
                return (
                  <DropdownItem key={'children-avids-dropdown-' + idx} onClick={() => this.updateHierarchyFilter(avid)}>
                    {avid.label}
                  </DropdownItem>
                );
              })}
            </DropdownMenu>
          </Dropdown>
        </>
      )
    }
  }

  resetFilters(): void {
    this.setInitialDateRangeState();
    const isMyAccessChecked = this.state.avidCheckboxes.find(i => i.id === "Bankwide_0").isChecked
    let reasonFilters = Object.assign(this.state.reasonFilters)
    reasonFilters.activeFilters = []

    let rootCauseFilters = Object.assign(this.state.rootCauseFilters)
    rootCauseFilters.activeFilters = []

    let severityFilters = Object.assign(this.state.severityFilters)
    severityFilters.activeFilters = []

    let sourceFilters = Object.assign(this.state.sourceFilters)
    sourceFilters.activeFilters = []

    let statusFilters = Object.assign(this.state.statusFilters)
    statusFilters.activeFilters = []

    this.setState({reasonFilters, rootCauseFilters, severityFilters, sourceFilters, statusFilters}, () => {
      this.filtersHandler()
      if (isMyAccessChecked) {
        this.toggleTeamCheckbox('myAlerts', 'myAlerts');
        this.filtersHandler()
      }
    })
  }

  render() {
    const { reasonFilters, statusFilters, rootCauseFilters, trendInputs, severityFilters, sourceFilters, isTeamFilterCollapsed, avidCheckboxes, AvidsList } = this.state;
    const isMyAccessChecked = (this.state.avidCheckboxes.find(i => i.id === "Bankwide_0") ? this.state.avidCheckboxes.find(i => i.id === "Bankwide_0").isChecked : false)
    const showResetButton = reasonFilters.hasFilters || rootCauseFilters.hasFilters || severityFilters.hasFilters || sourceFilters.hasFilters || statusFilters.hasFilters || isMyAccessChecked
    return (
      <div className="card filers-bar-component sticky-top">
        <div className="card-body">
          { showResetButton ?
            <div className="center-block">
            <button type="button" className="btn btn-outline-dark btn-sm" onClick={() => this.resetFilters()}>Reset
              Filters
            </button>
          </div>
            :
            null
          }
          {this.renderDatePicker()}
          {this.renderCheckBoxFilterList(reasonFilters, 'reasonFilters')}
          { AvidsList.length > 0 &&
            <TeamSelector
            avidList={AvidsList}
            checkBoxes={avidCheckboxes}
            isCollapsed={isTeamFilterCollapsed}
            updateCollapseState={() => {
              this.setState({isTeamFilterCollapsed: !isTeamFilterCollapsed})
            }}
            updateChildrenCollapseState={(avid) => {
              let newAvidList = Object.assign(this.state.AvidsList);
              newAvidList.forEach((avidItem) => {
                if (avidItem.id == avid) avidItem.childrenCollapsed = !avidItem.childrenCollapsed;
              })
              this.setState({AvidsList: newAvidList});
            }}
            toggleTeamCheckbox={(selectedAvid) => this.toggleTeamCheckbox(selectedAvid, selectedAvid)}
          />}
          {this.renderCheckBoxFilterList(statusFilters, 'statusFilters')}
          {this.renderCheckBoxFilterList(sourceFilters, 'sourceFilters')}
          {this.renderRadioGroup(trendInputs, 'trendInputs')}
          {this.renderCheckBoxFilterList(rootCauseFilters, 'rootCauseFilters')}
          {this.renderCheckBoxFilterList(severityFilters, 'severityFilters')}
        </div>
      </div>
    );
  }
}
